export default "__VITE_ASSET__DYQb2CcO__"